import ActionType from '../../actions/ActionType'

const defaultState = {
  A: {
    checked: false,
    field: '',
    type: 'S',
  },
  B: {
    checked: false,
    field: '',
    type: 'S',
  },
  C: {
    checked: false,
    field: '',
    type: 'S',
  },
  D: {
    checked: false,
    field: '',
    type: 'S',
  },
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case ActionType.Contacts.HANDLE_CHECKBOX_CHANGE:
      return {
        ...state,
        [action.payload.name]: {
          ...state[action.payload.name],
          checked: action.payload.checked,
        },
      }
    case ActionType.Contacts.HANDLE_FIELD_MODAL_CHANGE:
      return {
        ...state,
        [action.payload.name]: {
          ...state[action.payload.name],
          field: action.payload.value,
        },
      }
    case ActionType.Contacts.CLOSE_ADD_DETAILS_MODAL:
      return {
        ...defaultState,
        ...state,
      }
    case ActionType.Contacts.GET_CUSTOM_ATTRIBUTES_SUCCESS:
      const newCustomAttributes = {}
      action.payload.forEach(el => {
        newCustomAttributes[el.name] = { checked: false, field: el.name, type: el.type }
      })
      return {
        ...state,
        ...newCustomAttributes,
      }
    default:
      return state
  }
}
